import numeral from 'numeral';
import moment from 'moment';

export const FLATPICKR_FORMAT = 'm/j/y';

export default {
    formatPrice: (n) => numeral(n).format('0,0.00'),

    formatDate: (d) => moment(d).format('dddd LL'),

    formatShortDate: (d) => moment(d).format('L'),

    amountClass: (t) =>
        ['credit', 'adjustment'].indexOf(t.type) > -1
            ? 'text-success'
            : 'text-danger',

    truncateString: (s, l = 32) =>
        s.length > l ? s.substring(0, l) + '\u2026' : s,

    formatString: (source, params) => {
        $.each(params, function (i, n) {
            source = source.replace(new RegExp('\\{' + i + '\\}', 'g'), n);
        });
        return source;
    },
    isDateRangeSoldTO: (soldTo) =>  
        process.env.DATE_RANGE_SOLDTO_ACCOUNTS.includes(soldTo) ? true: false,
    
};



// WEBPACK FOOTER //
// ./app/utils.js